import { LocationState, toStateKey } from './types';
export default {
  isLoading: (state: LocationState) => state.status.startsWith('fetching'),
  canSelectCountries: (state: LocationState) => state.status.startsWith('ready'),
  canSelectStates: (state: LocationState) => state.status === 'ready:states' || state.status === 'ready:cities',
  canSelectCities: (state: LocationState) => state.status === 'ready:cities',
};
